
// sticky mobile buy bar after the hero
const bar=document.getElementById('buybar'), hero=document.querySelector('.strip');
new IntersectionObserver(([e])=>{bar.classList.toggle('is-on',!e.isIntersecting&&e.boundingClientRect.top<0)},
  {threshold:0}).observe(hero);
// FAQ: one open at a time
document.querySelectorAll('.faq details').forEach(d=>d.addEventListener('toggle',()=>{
  if(d.open) document.querySelectorAll('.faq details').forEach(o=>{if(o!==d)o.open=false});
}));

/* La demo non puo' vivere come pagina a se' su Shopify: il bottone e il QR
   la aprono a tutto schermo riusando lo srcdoc gia' presente in pagina. */
(function () {
  function close() {
    var o = document.getElementById("qrm-demo-ov");
    if (o) { o.remove(); document.documentElement.style.overflow = ""; }
  }
  function openDemo() {
    if (document.getElementById("qrm-demo-ov")) return;
    var f = document.querySelector(".qrm iframe[srcdoc]");
    if (!f) return;
    var o = document.createElement("div");
    o.id = "qrm-demo-ov";
    o.style.cssText = "position:fixed;inset:0;z-index:99999;background:rgba(10,10,12,.92);" +
      "display:flex;align-items:center;justify-content:center;padding:18px";
    o.innerHTML =
      '<button type="button" aria-label="Close" style="position:absolute;top:12px;right:14px;' +
      "width:40px;height:40px;border:0;border-radius:50%;background:#fff;color:#111;font-size:24px;" +
      'line-height:1;cursor:pointer">&times;</button>' +
      '<div style="width:min(390px,100%);height:min(844px,90vh);background:#fff;border-radius:22px;' +
      'overflow:hidden;box-shadow:0 22px 60px rgba(0,0,0,.55)">' +
      '<iframe title="Live digital menu demo" style="width:100%;height:100%;border:0;display:block"></iframe></div>';
    o.querySelector("iframe").setAttribute("srcdoc", f.getAttribute("srcdoc"));
    o.querySelector("button").addEventListener("click", close);
    o.addEventListener("click", function (e) { if (e.target === o) close(); });
    document.body.appendChild(o);
    document.documentElement.style.overflow = "hidden";
  }
  document.addEventListener("click", function (e) {
    var t = e.target.closest && e.target.closest("[data-qrm-demo]");
    if (t) { e.preventDefault(); openDemo(); }
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });
  if (/[?&]demo=1/.test(location.search)) {
    if (document.readyState === "complete") openDemo();
    else window.addEventListener("load", openDemo);
  }
})();
